"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FaceUnamused = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const FaceUnamused = _ref => {
  let {
    spotColor = "#FCB5A9",
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 37"
  }, props), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
    id: "face_salmon_unamused_svg__a",
    d: "M0 0h37v37H0z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "face_salmon_unamused_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#face_salmon_unamused_svg__a"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    d: "M1 18.5C1 28.15 8.85 36 18.5 36S36 28.15 36 18.5 28.15 1 18.5 1 1 8.85 1 18.5Z",
    mask: "url(#face_salmon_unamused_svg__b)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    d: "M18.5 0C28.7 0 37 8.299 37 18.5S28.7 37 18.5 37C8.298 37 0 28.701 0 18.5S8.298 0 18.5 0Zm0 1.517C9.135 1.517 1.517 9.136 1.517 18.5S9.135 35.483 18.5 35.483 35.483 27.864 35.483 18.5 27.865 1.517 18.5 1.517Zm.135 21.647c3.47 0 6.682 1.573 8.81 4.318a.81.81 0 0 1-.143 1.14.808.808 0 0 1-1.14-.143 9.467 9.467 0 0 0-7.527-3.691 9.5 9.5 0 0 0-7.301 3.412.812.812 0 1 1-1.245-1.042 11.117 11.117 0 0 1 8.546-3.994Zm-5.937-13.33c.798 0 1.645.578 1.645 1.648 0 1.07-.847 1.645-1.645 1.645-.421 0-.817-.146-1.117-.412-.342-.304-.53-.741-.53-1.233 0-1.07.849-1.649 1.647-1.649Zm12.356 0c.798 0 1.648.578 1.648 1.648 0 1.07-.85 1.645-1.648 1.645-.421 0-.818-.146-1.117-.412-.342-.303-.53-.74-.53-1.233 0-1.07.848-1.649 1.647-1.649Zm-12.356 1.27c-.141 0-.377.05-.377.378 0 .327.236.376.377.376.14 0 .375-.05.375-.376 0-.129-.035-.225-.103-.286a.412.412 0 0 0-.272-.092Zm12.356 0c-.141 0-.377.05-.377.378 0 .327.236.376.377.376.141 0 .378-.05.378-.376 0-.128-.035-.224-.103-.286a.42.42 0 0 0-.275-.092Z",
    mask: "url(#face_salmon_unamused_svg__b)"
  })));
};
exports.FaceUnamused = FaceUnamused;
FaceUnamused.displayName = "FaceUnamused";